<div class="cnt-column-centered downgrade-window" data-testid="confirmcopywindow">
    <div class="gradient-line"></div>
    <div class="downgrade-header">
        <div class="downgrade-title-text" i18n>Downgrade</div>
        <div class="close-btn" (click)="handleDontDowngrade()"></div>
    </div>
    <div [height]="40"></div>
    <div class="cnt-column-centered">
        <span style="color: #2D3646; font-size: 18px; margin-bottom: 5px">{{ 'PLEASE_CONFIRM_THAT_YOU_WISH' | translate }}</span>
        <span style="color: #2D3646; font-size: 18px;">{{ 'BRIXX_SUBSCRIPTION_PLAN' | translate }}</span>
    </div>

    <div [height]="40"></div>

    <div class="downgrade-info">
        <div class="line"></div>
        <div [height]="60" style="display: flex; justify-content: space-between; align-items: center">
            <div style="color: #2D3646; font-size: 17px;">{{ 'BRIXX_WITH' | translate }} <b>{{plansCount}}</b> {{ 'PLAN_S' | translate }}</div>
            <div style="color: #2D3646; font-size: 17px;">{{priceInfo}}</div>
        </div>

        <div class="line"></div>
        <div [height]="28"></div>
        <div class="downgrade-date-text">{{ 'STARTING' | translate }} {{downgradeDate}}</div>
        <div [height]="5"></div>
        <div style="color: rgba(66, 74, 93, 0.70); font-size: 16px">{{ 'CANCEL_OR_CHANGE_ANYTIME' | translate }}</div>
    </div>

    <div [height]="40"></div>

    <div class="action-buttons">
        <div class="action-btn cancel" (click)="handleDontDowngrade()">{{ 'cancel' | translate }}</div>
        <div [width]="20"></div>
        <div class="action-btn confirm" (click)="handleDowngrade()">{{ 'confirm' | translate }}</div>
    </div>
</div>
<!--<div [height]="20"></div>
<div class="p2Font b1Color txt" style="text-align: center;" *ngIf="!IsDowngradeWithSameFeatures" i18n>

    If you downgrade then you may lose access to some plans<br />
    and team members if you have too many. Downgrading will<br />
    occur at the end of the billing period. Are you sure you want<br />
    to downgrade.

</div>

<div class="p2Font b1Color txt" style="text-align: center;" *ngIf="IsDowngradeWithSameFeatures" i18n>

    Downgrading will occur at the end of the billing period. <br />
    Are you sure you want to downgrade?<br />

</div>

<div [height]="20"></div>

<div class="cnt-row-centered">
    <simple-btn [horizontalPadding]="32"
             [text]="downgradeText"
             [textCls]="'large-btn-text'"
             [height]="40"
             [cornerRadius]="50"
             [backgroundFillCls]="'transparent-background'"
             [hoverFillCls]="'g4Background'"
             [borderWidth]=2
             [borderColorCls]="'g4Border'"
             [hoverBorderColorCls]="'g4Border'"
             [textColorCls]="'g4Color'"
             [hoverTextColorCls]="'white-color'"
             data-testid="downgrade"
             (click)="handleDowngrade()">
    </simple-btn>

    <div [width]="10"></div>

    <simple-btn [horizontalPadding]="32"
            [textCls]="'large-btn-text'"
            [height]="40"
            [cornerRadius]="50"
            [backgroundFillCls]="'o2Background'"
            [hoverFillCls]="'o1Background'"
            [boxShadowCls]="'primary-shadow'"
            i18n-text
            text="Don't downgrade"
            data-testid="dontDowngrade"
            (click)="handleDontDowngrade()">
    </simple-btn>
</div>-->
